import { render } from "./PatientProfile.vue?vue&type=template&id=96583e2e&scoped=true"
import script from "./PatientProfile.vue?vue&type=script&lang=js"
export * from "./PatientProfile.vue?vue&type=script&lang=js"

import "./PatientProfile.vue?vue&type=style&index=0&id=96583e2e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96583e2e"]])

export default __exports__